export const findDefaultDecision = (analysis) => {
  if (!analysis?.success) {
    return "skip";
  }
  if (analysis.officeMatchBlocked) {
    return "skip";
  }
  if (analysis.identityMatchCandidate) {
    return "match";
  }
  return "new";
};
